<script>
  import WidgetCard from '../components/WidgetCard.svelte';
  import ViewStateHistoryModal from '../modals/ViewStateHistoryModal.svelte';
  import ViewErrorModal from '../modals/ViewErrorModal.svelte';
  import Tooltip from '../reusable components/tooltip.svelte';
  import formatDate from '../Helpers/DateTimeFormatter';
  import { Card, CardBody, CardHeader, CustomInput, Table, Button, CardFooter, Pagination, PaginationLink, PaginationItem, Spinner, ButtonDropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'sveltestrap';
  import { selectedGroup, currentPage } from '../store.js';
  import { onMount, onDestroy } from 'svelte';
  import http from '../api/http.js';
	import Search from '../components/Search.svelte';
	import TableColumn from '../components/TableColumn.svelte';
	import CreateCommand from './CreateCommand.svelte';
	import prettysize from 'prettysize';

  const allFilterState = 'all';
  const transitionFilterState = 'transition';
  const requiresActionFilterState = 'requiresaction';
  const completedFilterState = 'complete';

  let createCommand = false;
  let previousPageNumber = 0;
  let allCommandsSelected = false;
  let errorMessage = "";
  let filterState = 'all';
  let totalCommandCount = 0;
  let inProgressCommandCount = 0;
  let requiresActionCommandCount = 0;
  let completedCommandCount = 0;
  let includeCancelled = false;
  let isLoading = false;
  let searchRefresh = false;
  let inputLength = 0
  export let searchTerm = "";
  let pageNumber = 1;
  let totalPageCount = 0;
  let tableHeader = "All Commands";
  let createCommandModal;
  let stateHistoryModal;
  let viewErrorModal;
  let commands = [];
  let selectedCommands = [];
  let stateLegend = [
  {
    "name": "Pending",
    "value": "Awaiting user action.",
    "color": "warning"
  },
  {
    "name": "Creating Command",
    "value": "Your command is being built.",
    "color": "info"
  },
  {
    "name": "Awaiting Deployment Completion",
    "value": "Your Command will be sent once the Package is onboard.",
    "color": "info"
  },
  {
    "name": "Awaiting Collection",
    "value": "Your command is in the cloud waiting for the vessel to collect it.",
    "color": "info"
  },
  {
    "name": "Downloading",
    "value": "Your deployment is being downloaded by the vessel.",
    "color": "info"
  },
  {
    "name": "Cataloguing",
    "value": "The vessel is deserializing deployment contents.",
    "color": "info"
  },
  {
    "name": "In Progress",
    "value": "Your command is in progress on the vessel.",
    "color": "info"
  },
  {
    "name": "Complete",
    "value": "Your command has been carried out and has been successful.",
    "color": "success"
  },
  {
    "name": "Failed",
    "value": "Your command has been carried out and has failed.",
    "color": "danger"
  },
  {
    "name": "CompletedWithErrors",
    "value": "Your command has been carried out and has been successful but with errors.",
    "color": "danger"
  }
];

const displayNumbers = [10, 25, 50, 100, 200];

let displayNumber = displayNumbers[0];

let sortType = {
      ascending: 'ascending',
      descending: 'descending',
      resting: 'resting'
    }

  let activeColumn = {
    columnValue: 7,
    sortType: sortType.descending,
  };

  function toggleSort(columnValue, theSortType){
    if(activeColumn.value != columnValue){
      activeColumn.columnValue = columnValue;
    }
    switch(theSortType){
      case sortType.resting:
        activeColumn.sortType = sortType.ascending;
        break;
      case sortType.ascending:
        activeColumn.sortType = sortType.descending;
        break;
      case sortType.descending:
        activeColumn.sortType = sortType.ascending;
        break;
    }
    
    if(activeColumn.sortType != sortType.resting){
      getCommands(filterState, columnValue, activeColumn.sortType);
    }
    else{
      activeColumn.columnValue = 7;
      activeColumn.sortType = sortType.ascending;
      getCommands(filterState, 7, activeColumn.sortType);
    }
  }

  $: {    
    $selectedGroup;
    if ($selectedGroup != undefined){
      pageNumber = 1;
      loadCountsAndCommands();
    }  
  }

  $:activeColumn;

  $:{
    pageNumber;
    displayNumber;
    includeCancelled;
    getCommands(filterState, activeColumn.columnValue, activeColumn.sortType);
  }

   $: {
    if (previousPageNumber != pageNumber) {
      allCommandsSelected = false;
      previousPageNumber = pageNumber;
    }
  }

  $:{
    loadWidgetCounts();
    getCommands(filterState, activeColumn.columnValue, activeColumn.sortType);
  }

  async function loadCountsAndCommands(){
    await loadWidgetCounts();
    await getCommands(filterState, activeColumn.columnValue, activeColumn.sortType);
  }

  function setStatusColor(status){
    let color = "info";
    switch(status){
      case "Waiting": 
      case "Pending":
        color = "warning";
        break;
      case "In Progress":
      case "Awaiting Deployment Completion":
      case "Awaiting Collection":
        color = "info";
        break;
      case "Complete":
        color = "success";
        break;
      case "Failed":
      case "CompletedWithErrors":
        color = "danger";
        break;
    }
    return color;
  }
  
function setPageNumber(number){
    pageNumber = number;    
  }

 function setFilter(filter){
      if(filter == allFilterState){
          tableHeader = "All Commands";
          filterState = allFilterState;
      }
      else if(filter == transitionFilterState){
          tableHeader = "Commands In Progress";
          filterState = transitionFilterState;
      }
      else if(filter == requiresActionFilterState){
          tableHeader = "Commands Requiring Action";
          filterState = requiresActionFilterState;
      }
      else if(filter == completedFilterState){
          tableHeader = "Completed Commands";
          filterState = completedFilterState;
      }
  }

async function searchCommands(){ 
    searchRefresh = true;
    let interval = setInterval( async () => {
      if(searchTerm.length != inputLength){
        pageNumber = 1;
        getCommands(filterState, activeColumn.columnValue, activeColumn.sortType);   
      }
      if(!searchRefresh){
          clearInterval(interval);
      }
      inputLength = searchTerm.length;  
    }, 2000);    
  }

  async function getCommands(commandState, columnValue, sortTypeArg){
    if(!isLoading){
       let ascending = sortTypeArg == sortType.ascending ? true : false;
      errorMessage = "";
      let url = "";
      if(columnValue == undefined){
        columnValue = 7;
      }
      if(ascending == undefined){
        ascending = true;
      }
      isLoading = true;
      if(searchTerm.length > 0 && searchTerm != ""){
        url = `/deploy/dashboard/command/${$selectedGroup}/${searchTerm}/${displayNumber}/${pageNumber}/${filterState}/${includeCancelled}/${columnValue}/${ascending}`;
      }
      else{
        url = `/deploy/dashboard/command/${$selectedGroup}/${displayNumber}/${pageNumber}/${commandState}/${includeCancelled}/${columnValue}/${ascending}`;
      }
      const res = await http.get(window.apiBaseUrl + url);
      if(res.status == 200){
        let uiCommandCollection = await res.json();
        commands = uiCommandCollection.commands;
        totalPageCount = uiCommandCollection.totalPageCount; 
        isLoading = false;
        checkStoredCommands();
      }
      else if(res.status == 404){
        isLoading = false;
        commands = [];
      }
      else{
        errorMessage = "Something went wrong, please try again.";
        isLoading = false;
        commands = [];
      }
    }
  }

  async function loadWidgetCounts(){
    const totalRes = await http.get(window.apiBaseUrl + `/deploy/dashboard/command/all/count/${$selectedGroup}/${includeCancelled}`);
    if(totalRes.status == 200){
      totalCommandCount = await totalRes.json();
    }
    const inProgressRes = await http.get(window.apiBaseUrl + `/deploy/dashboard/command/transition/count/${$selectedGroup}/${includeCancelled}`);
    if(inProgressRes.status == 200){
      inProgressCommandCount = await inProgressRes.json();
    }
    const failedRes = await http.get(window.apiBaseUrl + `/deploy/dashboard/command/requiresaction/count/${$selectedGroup}/${includeCancelled}`);
    if(failedRes.status == 200){
      requiresActionCommandCount = await failedRes.json();
    }
    const completedRes = await http.get(window.apiBaseUrl + `/deploy/dashboard/command/complete/count/${$selectedGroup}/${includeCancelled}`);
    if(completedRes.status == 200){
      completedCommandCount = await completedRes.json();
    }
  }

  async function triggerCommands(){
    errorMessage = "";
    const res = await http.put(window.apiBaseUrl + `/deploy/dashboard/command/trigger/pending/${$selectedGroup}`, selectedCommands);
    selectedCommands.forEach((command) => {
      command.selected = false;
    })
    commands = commands;
    selectedCommands = [];
    selectedCommands = selectedCommands;
    if(res.status != 200){
       errorMessage = "Something went wrong, please try again.";
    }
    else{
      errorMessage = "";
       await loadCountsAndCommands();
    }
  }

  async function retryCommand(command){
    errorMessage = "";
    const res = await http.put(window.apiBaseUrl + `/deploy/dashboard/command/retry/${$selectedGroup}`, command);
    if(res.status == 200){
      await loadCountsAndCommands();
      commands = commands;
      isLoading = false;
    }
    else{
      errorMessage = "Something went wrong retrying the command, please try again.";
    }
  }

  async function cancelCommand(command){
    errorMessage = "";
    const res = await http.delete(window.apiBaseUrl + `/deploy/dashboard/command/${$selectedGroup}`, command);
    if(res.status == 200){
      await loadCountsAndCommands();
      commands = commands;
      isLoading = false;
    }
    else{
      errorMessage = "Something went wrong cancelling the command, please try again.";
    }
  }

  function selectCommand(command){
      if(command.selected){
        selectedCommands.push(command);
      }
      else{
        selectedCommands = selectedCommands.filter((c) => c.id != command.id);
      }
      commands = commands;
      selectedCommands = selectedCommands;
  }

  function selectAllCommands(){
    if(allCommandsSelected){
      commands.forEach(command => {
        command.selected = true;
        if(!selectedCommands.map(c => c.id).includes(command.id) && command.status.toLocaleLowerCase() == "pending"){
          selectedCommands.push(command);
        }
      });
    }
    else{
        commands.forEach(command => {
        command.selected = false;
        selectedCommands = selectedCommands.filter((c) => c.id != command.id);
      });
    }
    commands = commands;
    selectedCommands = selectedCommands;
  }

  function checkStoredCommands() {
    commands.forEach(command => {
      if (selectedCommands.map(c => c.id).includes(command.id)) {
        command.selected = true;
      }
    });
  }

  function viewLogs(command, logName){
    window.open(
      window.apiBaseUrl +
        `/deploy/dashboard/installations/log/view/${
          command.guid
        }/${logName}/${$selectedGroup}?_=${new Date().valueOf()}`,
      "_blank",
      "menubar=false"
    );
  };

  function downloadLogs(command, logName){
    window.open(
      window.apiBaseUrl +
        `/deploy/dashboard/installations/log/download/${
          command.guid
        }/${logName}/${$selectedGroup}?_=${new Date().valueOf()}`
    );
  };

  const interval = setInterval(loadCountsAndCommands, 30000);

  onMount(async () => {      
    currentPage.set('commands');
  });

  onDestroy(() => {
    clearInterval(interval);
  });
</script>
{#if createCommand == false}
  <div class="d-flex">
    <h4 class="font-weight-bold text-primary mb-0">Commands</h4>
    <div class="ml-auto">
      <CustomInput type="switch" on:change={() => includeCancelled = includeCancelled == false ? true : false} id="toggleIncludeCancelled" label="Show Cancelled Commands" checked={includeCancelled == true}></CustomInput>
    </div>
  </div>

  <p class="text-danger">{errorMessage}</p>

<div class="grid" id="grid">
  <WidgetCard id="total-commands-widget" title="All Commands" value="{totalCommandCount}" icon="download" color="info" withFooter=true on:mousedown={() => setFilter(allFilterState)} active={filterState == allFilterState} disabled={isLoading}>
    <p slot="footer" class="ml-auto">View</p>
  </WidgetCard>
  <WidgetCard id="in-progress-commands-widget" title="In Progress" value="{inProgressCommandCount}" icon="clock" color="warning" withFooter=true on:mousedown={() => setFilter(transitionFilterState)} active={filterState== transitionFilterState} disabled={isLoading}>
    <p slot="footer" class="ml-auto">View</p>
  </WidgetCard>
  <WidgetCard id="requiring-action-commands-widget" title="Requiring Action" value="{requiresActionCommandCount}" icon="exclamation" color="danger" withFooter=true on:mousedown={() => setFilter(requiresActionFilterState)} active={filterState == requiresActionFilterState} disabled={isLoading}>
    <p slot="footer" class="ml-auto">View</p>
  </WidgetCard>
  <WidgetCard id="complete-commands-widget" title="Completed" value="{completedCommandCount}" icon="check" color="success" withFooter=true on:mousedown={() => setFilter(completedFilterState)} hasBackgroundColor="true" backgroundColor="bg-success" className="success" active={filterState== completedFilterState} disabled={isLoading}>
    <p slot="footer" class="ml-auto">View</p>
  </WidgetCard>
</div>

<Card>
  <CardHeader>
    <div class="row">
        <div class="col-sm">
            <h6 class="font-weight-bold mt-2 mb-2">{tableHeader}</h6>
        </div>
        {#if isLoading}
          <Spinner color="primary" type="border"></Spinner>
        {/if}
         <div class="col-sm">
            <Search id="commands-search-input" bind:searchTerm placeholder="Search Commands..." on:input={() => searchCommands()}></Search>   
         </div>
        <div class="col-sm">
            <Button id="create-command-button" on:click={() => createCommand = !createCommand} color="primary" class="btn-plus btn-icon-split float-right ml-2">
                <span class="icon">
                  <i class="fas fa-plus" style="vertical-align:auto !important;"></i>
                </span>
              <span class="text">
                  Create New            
                </span>
            </Button>
            <Button id="command-selected-button" on:click={() => triggerCommands()} color="primary" class="btn-plus btn-icon-split float-right" disabled={selectedCommands.length == 0}>
                <span class="icon">
                  <i class="fas fa-paper-plane" style="vertical-align:auto !important;"></i>
                </span>
                <span class="text">
                    Trigger Selected  
                </span>
            </Button>    
        </div>
      </div>
    </CardHeader>
  <CardBody>
    {#if commands.length == 0}
      <p>No commands to display.</p>
    {:else}
      <Table responsive>
        <thead>
          <th><input class="mr-2" type="checkbox" bind:checked={allCommandsSelected} on:change={() => selectAllCommands()} id="select-all-commands">{selectedCommands.length > 0 ? `(${selectedCommands.length})` : ""}</th>
          <TableColumn on:mousedown={() => toggleSort(0, activeColumn.sortType)} active={activeColumn.columnValue == 0} sortType={activeColumn.sortType}>Vessel Name</TableColumn>
          <TableColumn on:mousedown={() => toggleSort(1, activeColumn.sortType)} active={activeColumn.columnValue == 1} sortType={activeColumn.sortType}>Host Name</TableColumn>
          <TableColumn on:mousedown={() => toggleSort(2, activeColumn.sortType)} active={activeColumn.columnValue == 2} sortType={activeColumn.sortType}>Package Name</TableColumn>
          <TableColumn on:mousedown={() => toggleSort(3, activeColumn.sortType)} active={activeColumn.columnValue == 3} sortType={activeColumn.sortType}>Package Version</TableColumn>
          <TableColumn on:mousedown={() => toggleSort(4, activeColumn.sortType)} active={activeColumn.columnValue == 4} sortType={activeColumn.sortType}>Command Type</TableColumn>
          <TableColumn on:mousedown={() => toggleSort(5, activeColumn.sortType)} active={activeColumn.columnValue == 5} sortType={activeColumn.sortType}>Status <Tooltip content={stateLegend} legend={true} title={"Command Status"}> <i class="fad fa-question-circle fa-sm font-weight-normal"></i></Tooltip></TableColumn>
          <TableColumn on:mousedown={() => toggleSort(6, activeColumn.sortType)} active={activeColumn.columnValue == 6} sortType={activeColumn.sortType}>Delayed</TableColumn>
          <TableColumn on:mousedown={() => toggleSort(7, activeColumn.sortType)} active={activeColumn.columnValue == 7} sortType={activeColumn.sortType}>Last Updated</TableColumn>
          <th>Delayed By</th>          
          <th>Actions</th>
        </thead>
        <tbody>          
          {#each commands as command}
            <tr id="command-row-{command.id}">
              {#if command.status == "Pending"}
                <td><input id="command-checkbox-{command.id}" type="checkbox" bind:checked={command.selected}  on:change={() => selectCommand(command)}/></td>
                {:else}
                <td></td>
              {/if}
              <td>{command.vesselName}</td>
              <td>{command.computerName}</td>
              <td>{command.packageName}</td>
              <td>{command.packageVersion}</td>
              <td>{command.commandType}</td>
              <td>
                <strong class="text-{setStatusColor(command.status)}">
                  {command.status}
                  {#if command.status.toLocaleLowerCase() == "downloading"}
                    {command.downloadPercentage}
                    <br>
                    {prettysize(command.downloadProgress)}&nbsp;/&nbsp;{prettysize(command.downloadPacketSize)}
                  {/if}
              </strong></td>
              <td>{command.delayed}</td>
              <td>{formatDate(command.lastUpdated)}</td>
              <td>{command.delayedBy}</td>
              <td>
                <ButtonDropdown isOpen={command.actionIsOpen} toggle={() => (command.actionIsOpen = !command.actionIsOpen)}>
                  <DropdownToggle caret color="primary">View Actions</DropdownToggle>
                   <DropdownMenu>
                      <DropdownItem id="view-command-history-{command.id}" on:click={() => stateHistoryModal.show(command.id, "Command", command.commandType)}>View History</DropdownItem>
                      {#if command.status.toLocaleLowerCase() == "failed"}
                        <DropdownItem id="retry-command-{command.id}" on:click={() => retryCommand(command)}>Retry</DropdownItem>
                      {/if}
                      {#if command.status.toLocaleLowerCase() == "pending" || command.status.toLocaleLowerCase() == "failed" || command.status.toLocaleLowerCase() == "awaitingdeploymentcompletion"}
                        <DropdownItem id="cancel-command-{command.id}" on:click={() => cancelCommand(command)}>Cancel</DropdownItem>
                      {/if}
                      {#await getCommands(filterState, activeColumn.columnValue, activeColumn.sortType)}
                        <DropdownItem disabled>No Logs To View</DropdownItem>
                        {:then}
                        {#if command.logs != null} 
                          {#each command.logs as log}
                            <DropdownItem id="view-logs-{log}-{command.id}" on:click={() => viewLogs(command, log)}>View {log}</DropdownItem>
                            <DropdownItem id="download-logs-{log}-{command.id}" on:click={() => downloadLogs(command, log)}>Download {log}</DropdownItem>
                          {/each}
                        {/if}
                      {/await}
                      {#if command.commandType.toLocaleLowerCase() == "Installation" && (command.status.toLocaleLowerCase() == "installedwitherrors" || command.status.toLocaleLowerCase() == "failed")}
                        <DropdownItem id="view-error-{command.id}" on:click={() => viewErrorModal.show(command)}>View Errors</DropdownItem>
                      {/if}
                   </DropdownMenu>
                </ButtonDropdown>   
              </td>
            </tr>
            {:else}
            <tr>
              <td colspan="7" class="text-center">No Commands Found</td>
            </tr>
         {/each}        
        </tbody>
      </Table>
    {/if}
  </CardBody>
  <CardFooter>

    <div class="pagination bg-light shadow-none ml-0 d-flex">
      {#if searchTerm.length > 0 && searchTerm != ""}
      <small class="mt-3 mr-auto">{pageNumber == 1 ? 1:(pageNumber - 1) * displayNumber + 1} - {(pageNumber * displayNumber > commands.length ? commands.length:pageNumber * displayNumber)} of {commands.length} commands</small>
      {:else}
        <small class="mt-3 mr-auto">{pageNumber == 1 ? 1:(pageNumber - 1) * displayNumber + 1} - {(pageNumber * displayNumber > totalCommandCount ? totalCommandCount:pageNumber * displayNumber)} of {totalCommandCount} commands</small>
      {/if}      
      <div class="mt-2 justify-content-center">
        <Pagination>
            <PaginationItem disabled={pageNumber == 1}>
              <PaginationLink id="pagination-first-page-button" first on:click={() => pageNumber = 1} href="#"/>
            </PaginationItem>

            <PaginationItem  disabled={pageNumber == 1}>
              <PaginationLink id="pagination-previous-page-button" previous on:click={() => setPageNumber(pageNumber - 1)} href="#" />
            </PaginationItem>

            {#if totalPageCount > 5}
              {#each Array(5) as _, count}
                {#if pageNumber > 3 && pageNumber < totalPageCount - 2}
                  <PaginationItem active={pageNumber == count + pageNumber} >
                    <PaginationLink id="pagination-page-{pageNumber + count}-button" on:click={() => setPageNumber(pageNumber + count)} href="#">{pageNumber + count}</PaginationLink>
                  </PaginationItem>
                {:else if pageNumber <= 3}
                  <PaginationItem active={pageNumber == count + 1} >
                    <PaginationLink id="pagination-page-{count + 1}-button" on:click={() => setPageNumber(count + 1)} href="#">{count + 1}</PaginationLink>
                  </PaginationItem>
                {:else if pageNumber >= totalPageCount - 2}
                  <PaginationItem active={pageNumber == totalPageCount - 4 + count} >
                    <PaginationLink id="pagination-page-{totalPageCount - 4 + count}-button" on:click={() => setPageNumber(totalPageCount - 4 + count)} href="#">{totalPageCount - 4 + count}</PaginationLink>
                  </PaginationItem>
                {/if}
              {/each}
            {:else}
              {#each Array(totalPageCount) as _, count}
                <PaginationItem active={pageNumber == count + 1} on:click={() => pageNumber == count + 1}>
                  <PaginationLink id="pagination-page-{count + 1}-button" on:click={() => setPageNumber(count + 1)} href="#">{count + 1}</PaginationLink>
                </PaginationItem>
              {/each}
            {/if}      

            <PaginationItem disabled={pageNumber == totalPageCount}>
              <PaginationLink id="pagination-next-page-button" next href="#" on:click={() => setPageNumber(pageNumber + 1)} />
            </PaginationItem>
            
            <PaginationItem disabled={pageNumber == totalPageCount}>
              <PaginationLink id="pagination-last-page-button" last href="#" on:click={() => setPageNumber(totalPageCount)}/>
            </PaginationItem>
          </Pagination>
      </div>
      <div class="mt-3 ml-auto">
        <select class="form-select" id="displayNumberSelect" bind:value={displayNumber}>
          {#each displayNumbers as displayNumber}
            <option value={displayNumber}>{displayNumber}</option>
          {/each}
        </select>
        <label class="ml-1" id="displayNumberLabel" for="displayNumberSelect">Per page</label>     
      </div>  
    </div>
    
  </CardFooter>
</Card>

<ViewStateHistoryModal  bind:this={stateHistoryModal}></ViewStateHistoryModal>
<ViewErrorModal bind:this={viewErrorModal}></ViewErrorModal>

{:else}
  <CreateCommand bind:visible={createCommand} on:commandCreated={() => loadCountsAndCommands()}/>
{/if}

<style>
  #displayNumberSelect{
    max-height: 30px;
    background-color: white;
    border-radius: 6px;
    border: 1px solid #DEDEDE;
    height:400px;
    color:#3a3a3a;
  }

  p{
    font-size: 0.8em;
  }

  select{
    background-color: white;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
  }

  .active{
    border: 2px solid #36b8cca1;
    border-radius: 0.5em;
  }
      
  .grid {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    display: grid;
    gap: 1em;
    margin-top: 1.5em;
    margin-bottom: 1.5em;
  }

.overlap{
  z-index: 100;
}

.toggle{
  cursor: pointer;
}
</style>

